export default {
  action: '#127d70',
  border: '#edf2f0',
  error: '#d9594c',
  grey: '#eaeaea',
  background: '#ffffff',
  backgroundSecondary: '#f9e6c8',
  button: '#d9594c',
  fontButton: '#ffffff',
  fontBody: '#1e1e24',
  fontHeading: '#084c61',
  fontInput: '#1e1e24',
  fontNavbar: '#084c61',
  fontPrice: '#56666b',
  fontMainBackgroundImage: '#ffffff',
  footer: '#ffffff',
  menu: '#f6f8f7',
  menuIndexButton: '#ffffff',
  menuIndexButtonText: '#1e1e24',
  navbarMenuLink: '#ffffff',
  navbarMenuLinkText: '#084c61',
  navbarIcon: '#ffffff',
  primary: '#edae49',
  roundButtonDiameter: 3,
  roundButtonLineHeight: 1.38,
  stickyFooter: '#ffffff',
  textTransformButton: 'none',
  white: '#ffffff',
};
